// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mpfexpEntity from './entities/mpfexp.json';
import mpfexpMenu from '../pages/mpfexp/menu.json';
import mpfexpFullForm from '../pages/mpfexp/forms/full.json';
import mpfexpContextForm from '../pages/mpfexp/forms/context.json';
import mpfexpMiniForm from '../pages/mpfexp/forms/mini.json';
import mpfexpLookupForm from '../pages/mpfexp/forms/lookup.json';
import mpfexpTableView from '../pages/mpfexp/views/table.json';
import mpfexpStagesView from '../pages/mpfexp/views/stages.json';
import mpfexpCardsView from '../pages/mpfexp/views/cards.json';
import mpfexpInlineView from '../pages/mpfexp/views/inline.json';
import mpfexpBacklogView from '../pages/mpfexp/views/backlog.json';
import mpfexpSplitView from '../pages/mpfexp/views/split.json';
import mpfexpCalendarView from '../pages/mpfexp/views/calendar.json';
import mpfexpDashboardView from '../pages/mpfexp/views/dashboard.json';

/** Тип запису «Видаток» зі сторінками пакета: меню, форми та подання з pages/mpfexp/. */
export const mpfexpDefinition: IRecordTypeDefinition = {
  ...mpfexpEntity,
  views: assembleViewSet({
      table: mpfexpTableView,
      stages: mpfexpStagesView,
      cards: mpfexpCardsView,
      inline: mpfexpInlineView,
      backlog: mpfexpBacklogView,
      split: mpfexpSplitView,
      calendar: mpfexpCalendarView,
      dashboard: mpfexpDashboardView,
  }),
  form: mpfexpFullForm,
  forms: { full: mpfexpFullForm, context: mpfexpContextForm, mini: mpfexpMiniForm, lookup: mpfexpLookupForm },
  menu: mpfexpMenu,
} as IRecordTypeDefinition;
